<template>
  <div class="restaurantBoxWrap" data-guide-key="Restaurant Selector">
    <el-popover ref="popover"
                placement="bottom-start" content=""
                title="" width="" trigger="manual"
                popper-class="restaurantBoxPopper"
                v-model="popoverVisible">
      <div class="restaurantBox" :class="{restaurantBox1:!isShow}" slot="reference" ref="reference" @click="popoverVisible = !popoverVisible">
        <AvatarInitial :name="activeRestaurant.restaurantName" size="lg"/>
        <template v-if="isShow">
          <AppTooltip v-if="isNameTruncated" :content="activeRestaurant.restaurantName" placement="bottom">
            <div class="name" ref="nameEl">{{activeRestaurant.restaurantName}}</div>
          </AppTooltip>
          <div v-else class="name" ref="nameEl">{{activeRestaurant.restaurantName}}</div>
        </template>
        <Icon name="unfold-more" class="more"/>
      </div>
      <div class="restaurantList">
        <p v-for="(item, index) in restaurantList"
           :class="{active: item.restaurantId === selectedRestaurantId}"
           :key="index"
           @click="changeRestaurant(item)">{{item.restaurantName}}</p>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { Icon } from 'tdesign-icons-vue'
import { mapMutations, mapState } from "vuex";
import AvatarInitial from "@/components/common/AvatarInitial.vue";
import AppTooltip from "@/components/common/AppTooltip.vue";

export default {
  name: "RestaurantBox",
  props: {
    isShow: { default: false }
  },
  components: { Icon, AvatarInitial, AppTooltip },
  data() {
    return {
      popoverVisible: false,
      activeRestaurant: { restaurantName: "" },
      // Only wrap the name in a tooltip once it's actually clamped — showing
      // a hover popup that just repeats text already fully visible is noise.
      isNameTruncated: false,
    }
  },
  computed: {
    ...mapState({
      selectedRestaurantId: state => state.restaurant.selectedRestaurantId,
      restaurantList: state => state.restaurant.restaurantList,
    })
  },
  watch: {
    selectedRestaurantId: {
      handler(val) {
        const match = this.restaurantList.find(r => r.restaurantId === val);
        if (match) this.activeRestaurant = match;
      },
      deep: true,
      immediate: true
    },
    restaurantList(newList) {
      const match = newList.find(r => r.restaurantId === this.selectedRestaurantId);
      if (match) {
        this.activeRestaurant = match;
      } else if (newList.length) {
        this.activeRestaurant = newList[0];
      }
    },
    activeRestaurant() {
      this.$nextTick(this.checkNameTruncated);
    },
    isShow() {
      this.$nextTick(this.checkNameTruncated);
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    this.$nextTick(this.checkNameTruncated);
  },
  methods: {
    // -webkit-line-clamp hides overflow without reflowing layout, so
    // scrollHeight (the untruncated content height) exceeding clientHeight
    // (the clamped box's rendered height) reliably means text was cut off.
    checkNameTruncated() {
      const el = this.$refs.nameEl;
      this.isNameTruncated = !!el && el.scrollHeight > el.clientHeight;
    },
    handleClickOutside(event) {
      if (!this.popoverVisible) return
      const triggerBtn = this.$refs.reference
      const popover = this.$refs.popover.$el
      const isClickInside = triggerBtn.contains(event.target) || popover.contains(event.target)
      if (!isClickInside) this.popoverVisible = false
    },
    ...mapMutations("restaurant", ["SET_selectedRestaurantId"]),
    changeRestaurant(data) {
      this.SET_selectedRestaurantId(data.restaurantId);
      this.popoverVisible = false;
      // 刷新前先回到顶部：否则浏览器会恢复刷新前的滚动位置，新餐厅停在上一家看到一半的地方
      window.scrollTo(0, 0);
      window.location.reload();
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
}
</script>

<style scoped lang="scss">
.restaurantBox {
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 0 9px;
  cursor: pointer;
  min-height: 48px;
  padding: 6px 4px;
  box-sizing: border-box;
  border: none;
  border-radius: 8px;
  background: transparent;
  transition: background 0.15s ease;
  &:hover {
    background: var(--sidebar-hover);
  }
  .name {
    font-family: InterMedium, sans-serif !important;
    font-weight: 600;
    font-size: 13px;
    line-height: 20px;
    white-space: wrap;
    color: var(--sidebar-text);
    flex: 1;
    min-width: 0;
    word-break: normal;
    overflow-wrap: normal;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .more {
    flex-shrink: 0;
    font-size: 18px;
    color: var(--sidebar-text-muted);
  }
}
.restaurantBox1 {
  padding: 6px;
  gap: 0;
  border: none;
  border-radius: 8px;
}
</style>

<style lang="scss">
.restaurantBoxPopper {
  padding: 8px;
  min-width: 300px !important;
  border-radius: 12px !important;
  .popper__arrow {
    display: none !important;
  }
  .restaurantList {
    max-height: 350px;
    overflow: auto;
    p {
      margin: 0;
      height: 40px;
      line-height: 40px;
      font-family: Inter, sans-serif !important;
      font-weight: 400;
      font-size: 14px;
      padding: 0 12px;
      cursor: pointer;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    p:hover {
      background: #FFF4EE;
      border-radius: 8px;
    }
    .active {
      background: #FEE9DC;
      border-radius: 8px;
      color: var(--biz-text); /* 选中项文字：深橙 #B4541A */
      font-weight: 600;
    }
  }
}
</style>
